module.exports = __webpack_public_path__ + "assets/total_leads.1b6f57be.svg";